import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import moment from 'moment';
import { getDescription } from 'src/app/enum/Configuration';
import { ActiveUserStorage } from 'src/app/services/active-user-storage.service';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { NotificationService } from 'src/app/services/notification-service';
import { PackageDataService } from 'src/app/services/package-data.service';
import { PromotionDataService } from 'src/app/services/promotion-data.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-manage-promotion-add',
  templateUrl: './manage-promotion-add.component.html',
  styleUrls: ['./manage-promotion-add.component.scss']
})
export class ManagePromotionAddComponent implements OnInit {
  serviceproviderlist: any
  // ProviderList: any[] = ["Vumatel", "Openserve", "Balwin Fibre",]
  serviceTypes = [
    { id: 1, name: 'New Application' },
    { id: 2, name: 'Service Upgrade' },
    { id: 3, name: 'Service Downgrade' },
    { id: 4, name: 'Moving Address' },
  ];
  filteredProviders: string[]
  promotionForm: any;
  ServiceProviderShow: boolean;
  minEndDate: Date;
  today: Date = new Date();
  searchTerm: string = '';
  data: any
  id
  dropdownSettings: any
  promodetails: any;
  selectedServiceProviders: any;
  checkdisable = false
  view: number;
  constructor(
    public lookupdataservice: LookupDataServiceService,
    public PackageDataService: PackageDataService,
    public formBuilder: FormBuilder,
    public dialog: MatDialog,
    public navigationService: NavigationService,
    public promotiondataservice: PromotionDataService,
    public ActivatedRoute: ActivatedRoute,
    public toast: NotificationService,
  ) {
    this.ActivatedRoute.params.subscribe((params: any) => {
      this.id = parseInt(params.id)
      this.view = parseInt(params.type)
    })
  }


  ngOnInit(): void {
    this.initform()
    this.getdata()

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'key',
      textField: 'value',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      itemsShowLimit: 1,
      closeDropDownOnSelection: true,
    };
  }

  initform() {
    this.promotionForm = this.formBuilder.group({
      promoName: [null, Validators.required],
      promoCode: [null, Validators.required],
      serviceProviderIds: [[], Validators.required],
      promoStartDate: [null, Validators.required],
      promoEndDate: [null, Validators.required],
      promotionValidity: [null, Validators.required],
      promotionValidityType: ['1', Validators.required],
      applicableServiceType: this.formBuilder.array([
        new FormControl(1)
      ], Validators.required)
    });

    if (this.id != 0 && this.view == 1) {
      this.promotionForm.disable()
      this.promotionForm.get('promoEndDate').enable()
      this.promotionForm.get('serviceProviderIds').enable()
      this.promotionForm.get('promotionValidity').enable()
      this.disableAllCheckboxes()
    }
    else if (this.view == 2) {
      this.promotionForm.disable()
      this.disableAllCheckboxes()
    }


  }


  onCheckboxChange(event: MatCheckboxChange, id: number): void {
    const formArray: FormArray = this.promotionForm.get('applicableServiceType') as FormArray;

    if (event.checked) {
      formArray.push(new FormControl(id)); // Add selected ID
    } else {
      let index = formArray.controls.findIndex(control => control.value === id);
      if (index !== -1) {
        formArray.removeAt(index); // Remove unselected ID
      }
    }
  }

  onStartDateChange(event: any) {
    const selectedStartDate = event.value;
    this.minEndDate = new Date(selectedStartDate);
    this.minEndDate.setDate(this.minEndDate.getDate() + 1);
  }

  goToManagePromotion() {
    this.navigationService.goToManagePromotion()
  }

  getdata() {
    this.promotiondataservice.GetServiceProviderListForPromo().subscribe((result) => {
      this.data = result

      this.serviceproviderlist = Object.entries(this.data.serviceProviders)
        .filter(([key]) => Number(key) !== 43)
        .map(([key, value]) => ({
          key: Number(key),
          value: value
        }));
      if (this.id != 0)
        this.promotiondataservice.getManagePromotionDetailsbyId(this.id).subscribe((result) => {
          this.promodetails = result
          debugger
          const selectedServiceProviders = this.serviceproviderlist.filter(sp =>
            result.serviceProviderIds.includes(sp.key) 
          );

          this.promotionForm.patchValue({
            ...result,
            // applicableCustomerType: result.applicableCustomerType.toString(),
            promotionValidityType: result.promotionValidityType.toString(),
            serviceProviderIds: selectedServiceProviders
          });
          const formArray = this.promotionForm.get('applicableServiceType') as FormArray;
          formArray.clear();

          // Populate FormArray with API data
          result.applicableServiceType.forEach(id => formArray.push(new FormControl(id)));

        })
      console.log(this.promotionForm.getRawValue())

    })



    // this.promotiondataservice.getManagePromotionDetails().subscribe((result)=>{
    //   let selectids=['1','2','3']
    //   const selectedProviders = this.serviceproviderlist.filter(provider => selectids.includes(provider.key));
    //   this.promotionForm.get('serviceProviderId')?.setValue(selectedProviders);
    //   console.log(this.serviceproviderlist);
    // })

  }
  goToManageService() {
    this.navigationService.goToManageService();
  }
  navigate() {
    if (this.promotionForm.valid) {
      if (this.view == 2)
        this.navigationService.goTopromotionsimulation(this.id, this.view)

      let value = this.promotionForm.getRawValue()
      if (value.promoStartDate == null || value.promoEndDate == null)
        this.toast.showError('Start date or End date need to be filled')

      value.promoStartDate = moment(value.promoStartDate).format("YYYY/MM/DD");
      value.promoEndDate = moment(value.promoEndDate).format("YYYY/MM/DD");
      let postdata = {
        ...value,
        // applicableCustomerType: parseInt(value.applicableCustomerType),
        promotionValidityType: parseInt(value.promotionValidityType),
        serviceProviderIds: value.serviceProviderIds.map(item => item.key)
      }
      if (this.promodetails) {
        postdata.id = this.id
        postdata.addorUpdate = 1
        postdata.priority = this.promodetails.priority
      }
      console.log(postdata);

      this.promotiondataservice.saveManagePromotionDetails(postdata).subscribe((result) => {
        if (result.serviceProviderId) {
          var provider = result.serviceProviderId.map(p => getDescription(p)).join(', ');
          const txt = `Promotion for ${provider} is already existing. Do you want to prioritize this?`;
          const yes = 'Yes'
          const no = 'No'
          Swal.fire({
            text: txt,
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: no,
            confirmButtonText: yes,
            confirmButtonColor: '#7D32DE',
            cancelButtonColor: '#23C00A',
          }).then((result) => {
            if (result.value)
              postdata.priority = true
            else
              postdata.priority = false

            this.promotiondataservice.saveManagePromotionDetails(postdata).subscribe((result) => {
              this.navigationService.goTopromotionsimulation(result.id, this.view)
            })
          })
        }
        else if (result)
          this.navigationService.goTopromotionsimulation(result.id, this.view)
      })
      // this.navigationService.goTopromotionsimulation(0)
    }
    else {
      this.promotionForm.markAllAsTouched();
      this.toast.showError("Please fill in the mandatory fields");

    }
  }

  disableAllCheckboxes(): void {
    this.checkdisable = true
  }

  convertToUpperCase(event: any) {
    event.target.value = event.target.value.toUpperCase();
  }

  preventLeadingSpace(event: Event) {
    const e = event as KeyboardEvent;
    const input = e.target as HTMLInputElement;

    if (e.key === ' ' && input.selectionStart === 0) {
      e.preventDefault();
    }
  }

  onlyNumbers(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    const key = event.key;
    if (key.length > 1) {
      return;
    }
    if (input.value.length === 0 && key === '0') {
      event.preventDefault();
    }
    if (!/^[0-9]$/.test(key)) {
      event.preventDefault();
      return;
    }
  }
  restrictSpecialChars(event: any) {
    const inputValue = event.target.value;
    const cleanValue = inputValue.replace(/[^a-zA-Z0-9]/g, '');
    event.target.value = cleanValue;
    const controlName = event.target.getAttribute('formControlName');
    this.promotionForm.get(controlName)?.setValue(cleanValue, { emitEvent: false });
  }

}




